import React from 'react'

import "./SurveyAlreadyCompleted.scss"

const SurveyAlreadyCompleted = () => {
  return (
    <div className="modern-assessment survey-completed">
      <div className="completion-icon warning">
        ℹ️
      </div>
      <h2 className="assessment-title">
        Zelfevaluatie al voltooid
      </h2>
      <p className="assessment-subtitle">
        U heeft deze zelfevaluatie reeds ingevuld. Bedankt voor uw deelname.
      </p>
    </div>
  )
}

export default SurveyAlreadyCompleted